// PLEX-6187: resuming a conversation a crash left mid-turn (rd #399). The backend refuses a
// resume it can't do with a 409 whose `reason` says what the client does instead.
export const RESUME_REFUSALS = ["turn_completed", "not_resumable", "stale_view"];

// The refusal a resume request's error stands for, or null when it isn't one. The live-turn
// 409 carries no reason and isn't a refusal: isLiveTurnConflict covers it. A backend without
// rd #399 validates its query strictly and answers `resume` with a 400 naming it; that one
// can't resume either, so it reads as not_resumable and the client continues as it did.
export const resumeRefusal = (error) => {
  if (error?.status === 409) {
    const reason = error.data?.reason;
    return RESUME_REFUSALS.includes(reason) ? reason : null;
  }
  if (error?.status === 400 && /\bresume\b/.test(error.message || "")) return "not_resumable";
  return null;
};

// The stand-in result for a call a crash cut off. The conversation GET pairs the call with it
// (rd history/repair.py, which reads every crashed record that way), and so does the loader.
export const INTERRUPTED_TOOL_TEXT = "Tool call failed: session was interrupted";

const isStandInResult = (block) => {
  const result = block?.toolResult;
  return !!result && result.status === "error" && result.content?.length === 1 &&
    result.content[0]?.text === INTERRUPTED_TOOL_TEXT;
};

// A turn of nothing but stand-in results for the calls of the turn before it: what a crash
// leaves at the end of a conversation once it's paired for display. The record itself ends
// at the calls (PLEX-6187).
export const isInterruptionStandIn = (turn, previous) => {
  const content = turn?.role === "user" ? turn.content || [] : [];
  const calls = new Set((previous?.content || []).map(b => b?.toolUse?.toolUseId).filter(Boolean));
  return content.length > 0 && content.every(b => isStandInResult(b) && calls.has(b.toolResult.toolUseId));
};

// That turn, at the end of a loaded conversation, is flagged displayOnly. Until a dispatch
// sends it to the model it isn't part of the conversation: it isn't saved, and a resume
// doesn't send it.
export const withoutDisplayOnly = (turns) => (turns || []).filter(t => !t?.displayOnly);
